module.exports = __webpack_public_path__ + "img/ttb-logo.3d7ddccc.png";